import { render, staticRenderFns } from "./BlogHeadingElement.vue?vue&type=template&id=c085b946&scoped=true&"
import script from "./BlogHeadingElement.vue?vue&type=script&lang=js&"
export * from "./BlogHeadingElement.vue?vue&type=script&lang=js&"
import style0 from "./BlogHeadingElement.vue?vue&type=style&index=0&id=c085b946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c085b946",
  null
  
)

export default component.exports